import styled from '@emotion/styled';
import { Button, FileDisplaySection, Modal } from '@ui-components/neo.tax';

export const TicketingFileUploadModalStyled = styled(Modal)({
  minWidth: 500,
  maxWidth: 500,
});

export const StyledFileDisplaySection = styled(FileDisplaySection)({
  minHeight: 100,
  maxHeight: 100,
  overflow: 'auto',
});

export const StyledButton = styled(Button)({
  flex: 1,
  margin: 0,
});
